<template>
    <div class="project-home">
        <!-- 轮播 / Hero -->
        <div class="banner-wrapper">
            <el-carousel indicator-position="none" :interval="5000">
                <el-carousel-item class="default-banner">
                    <div class="banner-inner">
                        <h2 class="banner-title">{{ currentProject.name || '项目主页' }}</h2>
                        <p class="banner-subtitle wes" v-if="currentProject.introduction">
                            {{ currentProject.introduction }}
                        </p>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <banner-switch-tab active="project" />
        </div>

        <main class="ph-main">
            <div class="ph-wrap">
                <!-- 项目简报 + 通知公告 -->
                <div class="row-top">
                    <div class="left-col">
                        <div class="section-card brief-card">
                            <div class="section-hd">
                                <h3><i class="brief-icon"></i>项目简报</h3>
                                <a href="javascript:;" class="more-link" @click.prevent="goBriefList">更多<i class="el-icon-arrow-right"></i></a>
                            </div>
                            <ul class="news-list" v-loading="briefLoading">
                                <li v-for="item in briefList" :key="item.id || item.identifier">
                                    <a href="javascript:;" class="news-item" @click.prevent="goBriefPreview(item)">
                                        <span class="news-title"><i class="dot"></i>{{ item.name }}</span>
                                        <span class="news-date">{{ formatBriefDate(item.createTime) }}</span>
                                    </a>
                                </li>
                                <li v-if="!briefLoading && briefList.length === 0" class="brief-empty-item">
                                    <ph-empty size="panel" text="暂无周报" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="right-col">
                        <div class="notice-block">
                            <div class="notice-banner">
                                <div class="notice-icon">
                                    <i class="el-icon-message-solid"></i>
                                </div>
                                <div class="notice-banner-title">通知公告</div>
                                <a href="javascript:;" class="notice-more" @click.prevent="goNoticeList">更多<i class="el-icon-arrow-right"></i></a>
                            </div>
                            <div
                                class="notice-body"
                                :class="{ 'is-empty': !noticeLoading && !noticeList.length }"
                                v-loading="noticeLoading"
                            >
                                <template v-if="noticeList.length">
                                <div class="notice-date">
                                    <span class="day">{{ noticeDay }}</span>
                                    <span class="md">{{ noticeMd }}</span>
                                </div>
                                <div class="notice-list">
                                    <a
                                        v-for="item in noticeList"
                                        :key="item.id"
                                        href="javascript:;"
                                        @click.prevent="goNoticeDetail(item)"
                                    >
                                        <span class="notice-item-title"><i class="dot"></i>{{ item.title }}</span>
                                    </a>
                                </div>
                                </template>
                                <ph-empty
                                    v-else-if="!noticeLoading"
                                    size="panel"
                                    text="暂无通知公告"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 关键指标 -->
                <div class="stats-bar" v-loading="statsLoading" v-if="!statsEmpty">
                    <div class="stat-item" v-for="item in statsBar" :key="item.label">
                        <div class="stat-icon">
                            <i :class="item.icon"></i>
                        </div>
                        <div>
                            <div class="stat-num">{{ item.value }}<small>{{ item.unit }}</small></div>
                            <div class="stat-label">{{ item.label }}</div>
                        </div>
                    </div>
                </div>
                <div class="stats-empty-wrap" v-else v-loading="statsLoading">
                    <ph-empty v-if="!statsLoading" size="panel" text="暂无统计数据" />
                </div>

                <!-- 空间课表 -->
                <div class="section-card schedule-section">
                    <div class="section-hd">
                        <h3>空间课表</h3>
                        <a href="javascript:;" class="more-link" @click.prevent="goScheduleList">更多<i class="el-icon-arrow-right"></i></a>
                    </div>
                    <div class="schedule-tabs-wrap" v-if="spaceTabs.length">
                        <button
                            type="button"
                            class="schedule-tabs-nav prev"
                            :class="{ 'is-disabled': !spaceTabsCanScrollLeft }"
                            :disabled="!spaceTabsCanScrollLeft"
                            @click="scrollSpaceTabs(-1)"
                            title="向左"
                        >
                            <i class="el-icon-arrow-left"></i>
                        </button>
                        <div class="region-filter schedule-tabs">
                            <div
                                class="region-filter-btns schedule-tabs-btns"
                                ref="spaceTabsScroll"
                                @scroll="updateSpaceTabsScrollState"
                            >
                                <button
                                    v-for="space in spaceTabs"
                                    :key="space.key"
                                    type="button"
                                    class="region-btn"
                                    :class="{ 'is-active': activeSpace === space.key }"
                                    :title="space.name"
                                    @click="selectSpaceTab(space.key)"
                                >{{ space.name }}</button>
                            </div>
                        </div>
                        <button
                            type="button"
                            class="schedule-tabs-nav next"
                            :class="{ 'is-disabled': !spaceTabsCanScrollRight }"
                            :disabled="!spaceTabsCanScrollRight"
                            @click="scrollSpaceTabs(1)"
                            title="向右"
                        >
                            <i class="el-icon-arrow-right"></i>
                        </button>
                    </div>
                    <div class="schedule-tabs-empty" v-else-if="!spaceTabsLoading">
                        <span>暂无校级空间</span>
                    </div>
                    <div class="schedule-toolbar">
                        <div class="week-toolbar-left">
                            <span class="week-chip-label">本周课表</span>
                            <span class="week-this-tag" v-if="weekOffset === 0">本周</span>
                        </div>
                        <div class="week-toolbar-right">
                            <button
                                type="button"
                                class="week-nav"
                                :disabled="!canSchedulePrev"
                                @click="shiftWeek(-1)"
                                title="上一周"
                            >
                                <i class="el-icon-arrow-left"></i>
                            </button>
                            <span class="week-chip-range">{{ weekLabel }}</span>
                            <button
                                type="button"
                                class="week-nav"
                                :disabled="!canScheduleNext"
                                @click="shiftWeek(1)"
                                title="下一周"
                            >
                                <i class="el-icon-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="schedule-body" v-loading="scheduleLoading">
                        <div class="schedule-grid">
                            <div
                                class="schedule-day"
                                v-for="day in currentWeekDays"
                                :key="day.key"
                                :class="{ 'is-weekend': day.isWeekend, 'has-event': day.events.length }"
                            >
                                <div class="schedule-day-head">
                                    <span class="day-label">{{ day.label }}</span>
                                    <span class="day-num">{{ day.dayNum }}</span>
                                </div>
                                <div class="schedule-day-body is-home">
                                    <template v-if="day.events && day.events.length">
                                        <div
                                            v-for="(ev, idx) in day.events"
                                            :key="idx"
                                            class="schedule-event"
                                            :class="ev.typeClass"
                                        >
                                            <div class="ev-top">
                                                <span class="ev-badge">{{ eventTypeLabel(ev.typeClass) }}</span>
                                                <span class="ev-time"><i class="el-icon-time"></i>{{ eventTimeOnly(ev.time) }}</span>
                                            </div>
                                            <div class="ev-title" :title="ev.title">{{ ev.title }}</div>
                                            <div class="ev-meta">
                                                <span><i class="el-icon-user"></i>{{ ev.className }}</span>
                                            </div>
                                        </div>
                                    </template>
                                    <ph-empty
                                        v-else
                                        size="compact"
                                        text="暂无课程"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="schedule-legend">
                        <span><i class="lg-online"></i>直播课</span>
                        <span><i class="lg-live"></i>录播课</span>
                        <span><i class="lg-offline"></i>线下活动</span>
                    </div>
                </div>

                <!-- 结对空间统计 -->
                <div class="section-card stats-section">
                    <div class="section-hd">
                        <h3>结对空间统计</h3>
                        <a href="javascript:;" class="more-link" @click.prevent="goSpaceStatsList">更多<i class="el-icon-arrow-right"></i></a>
                    </div>
                    <div class="region-metrics" v-loading="provinceStatsLoading">
                        <div class="metrics-grid">
                            <div class="metric-card">
                                <h4>覆盖学校数量</h4>
                                <div
                                    class="hbar-list"
                                    :class="{ 'is-scrollable': schoolMetrics.length > 8 }"
                                    v-if="schoolMetrics.length"
                                >
                                    <div
                                        class="hbar-row"
                                        v-for="(item, idx) in schoolMetrics"
                                        :key="'school-' + (item.provinceId || item.label) + '-' + idx"
                                    >
                                        <span class="hbar-label" :title="item.label">{{ item.label }}</span>
                                        <div class="hbar-track">
                                            <div
                                                class="hbar-fill"
                                                :class="'c' + ((idx % 6) + 1)"
                                                :style="{ width: item.percent + '%' }"
                                            ></div>
                                        </div>
                                        <span class="hbar-value">{{ item.value }} 所</span>
                                    </div>
                                </div>
                                <ph-empty
                                    v-else-if="!provinceStatsLoading"
                                    size="panel"
                                    text="暂无学校数据"
                                />
                            </div>
                            <div class="metric-card">
                                <h4>参与人数</h4>
                                <div
                                    class="hbar-list"
                                    :class="{ 'is-scrollable': peopleMetrics.length > 8 }"
                                    v-if="peopleMetrics.length"
                                >
                                    <div
                                        class="hbar-row"
                                        v-for="(item, idx) in peopleMetrics"
                                        :key="'people-' + (item.provinceId || item.label) + '-' + idx"
                                    >
                                        <span class="hbar-label" :title="item.label">{{ item.label }}</span>
                                        <div class="hbar-track">
                                            <div
                                                class="hbar-fill"
                                                :class="'c' + ((idx % 6) + 1)"
                                                :style="{ width: item.percent + '%' }"
                                            ></div>
                                        </div>
                                        <span class="hbar-value">{{ item.valueText }}</span>
                                    </div>
                                </div>
                                <ph-empty
                                    v-else-if="!provinceStatsLoading"
                                    size="panel"
                                    text="暂无人数数据"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="region-filter" v-if="!spaceRegionEmpty">
                        <div class="region-filter-btns">
                            <button
                                v-for="pair in pairFilters"
                                :key="pair.key"
                                type="button"
                                class="region-btn"
                                :class="{ 'is-active': activePair === pair.key }"
                                @click="onPairFilterChange(pair.key)"
                            >{{ pair.name }}<span class="count">({{ pair.count }})</span></button>
                        </div>
                    </div>
                    <div class="table-scroll" v-loading="spaceListLoading" v-if="!spaceRegionEmpty">
                        <table class="data-table">
                            <thead>
                                <tr>
                                    <th>空间名称</th>
                                    <th>省区</th>
                                    <th>结对校单位</th>
                                    <th>班级空间</th>
                                    <th>成员</th>
                                    <th>课程</th>
                                    <th>作业</th>
                                    <th>观思问</th>
                                    <th>资源</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in spaceRows" :key="row.spaceId || row.name">
                                    <td class="name-cell">{{ row.name }}</td>
                                    <td>
                                        <span
                                            v-if="row.regionLabel"
                                            class="prov-tag"
                                        >{{ row.regionLabel }}</span>
                                        <span v-else>--</span>
                                    </td>
                                    <td>{{ row.partners || '--' }}</td>
                                    <td>{{ row.classes }}</td>
                                    <td>{{ row.members }}</td>
                                    <td>{{ row.courses }}</td>
                                    <td>{{ row.works }}</td>
                                    <td>{{ row.gsw }}</td>
                                    <td>{{ row.resources }}</td>
                                </tr>
                                <tr v-if="!spaceListLoading && spaceRows.length === 0">
                                    <td colspan="9" class="empty-cell">
                                        <ph-empty size="table" text="暂无空间数据" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="pager-wrap" v-if="!spaceRegionEmpty && spaceListPages.total > 0">
                        <pagination
                            :total="spaceListPages.total"
                            :page.sync="spaceListPages.currentPage"
                            :limit.sync="spaceListPages.pageSize"
                            @pagination="handleSpacePageChange"
                        />
                    </div>
                    <div
                        class="space-block-empty"
                        v-else-if="!spaceRegionLoading && spaceRegionEmpty"
                    >
                        <ph-empty size="panel" text="暂无空间统计" />
                    </div>
                </div>

                <!-- 精彩课堂 -->
                <div class="section-card courses-section">
                    <div class="section-hd">
                        <h3>精彩课堂</h3>
                        <a href="javascript:;" class="more-link" @click.prevent="goCoursesList">更多<i class="el-icon-arrow-right"></i></a>
                    </div>
                    <div class="course-body" v-loading="courseLoading">
                        <div class="course-grid" v-if="courseList.length">
                            <a
                                v-for="(course, idx) in courseList"
                                :key="course.id || idx"
                                href="javascript:;"
                                class="course-tile"
                                @click.prevent="toCourseDetail(course, idx)"
                            >
                                <div
                                    class="course-thumb"
                                    :style="course.coverStyle"
                                >
                                    <span class="course-badge" v-if="course.badge">{{ course.badge }}</span>
                                </div>
                                <div class="course-meta">
                                    <h4>{{ course.title }}</h4>
                                    <p class="course-desc">{{ course.desc }}</p>
                                    <div class="course-tags" v-if="course.tags && course.tags.length">
                                        <span
                                            v-for="tag in course.tags"
                                            :key="tag"
                                            class="course-tag"
                                        >{{ tag }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div v-else-if="!courseLoading" class="course-empty">
                            <ph-empty size="panel" text="暂无精彩课堂" />
                        </div>
                    </div>
                </div>

                <!-- 结对班级统计 -->
                <div class="section-card stats-section">
                    <div class="section-hd">
                        <h3>结对班级统计</h3>
                        <a href="javascript:;" class="more-link" @click.prevent="goClassStatsList">更多<i class="el-icon-arrow-right"></i></a>
                    </div>
                    <div class="table-scroll" v-loading="classListLoading">
                        <table class="data-table">
                            <thead>
                                <tr>
                                    <th>结对班级</th>
                                    <th>所属校级空间名称</th>
                                    <th>成员数</th>
                                    <th>课程</th>
                                    <th>作业</th>
                                    <th>观思问</th>
                                    <th>成果</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in classRows" :key="row.spaceId || row.name">
                                    <td class="name-cell">{{ row.name }}</td>
                                    <td>{{ row.space || '--' }}</td>
                                    <td>{{ row.members }}</td>
                                    <td>{{ row.courses }}</td>
                                    <td>{{ row.works }}</td>
                                    <td>{{ row.gsw }}</td>
                                    <td>{{ row.results }}</td>
                                </tr>
                                <tr v-if="!classListLoading && classRows.length === 0">
                                    <td colspan="7" class="empty-cell">
                                        <ph-empty size="table" text="暂无班级数据" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="pager-wrap" v-if="classListPages.total > 0">
                        <pagination
                            :total="classListPages.total"
                            :page.sync="classListPages.currentPage"
                            :limit.sync="classListPages.pageSize"
                            @pagination="handleClassPageChange"
                        />
                    </div>
                </div>

                <!-- 风采展示 -->
                <div class="section-card showcase">
                    <div class="section-hd">
                        <h3>风采展示</h3>
                        <a href="javascript:;" class="more-link" @click.prevent="goShowcaseList">更多<i class="el-icon-arrow-right"></i></a>
                    </div>
                    <div class="showcase-body" v-loading="showcaseLoading">
                        <div class="showcase-carousel-wrap" v-if="showcaseList.length">
                            <button
                                v-if="showcaseList.length > 1"
                                type="button"
                                class="showcase-arrow prev"
                                @click="prevShowcase"
                            >
                                <i class="el-icon-arrow-left"></i>
                            </button>
                            <div class="showcase-stage">
                                <div class="showcase-main">
                                    <div
                                        class="showcase-track"
                                        :style="{ transform: `translateX(-${showcaseIndex * 100}%)` }"
                                    >
                                        <div
                                            v-for="(slide, idx) in showcaseList"
                                            :key="slide.id || idx"
                                            class="showcase-slide"
                                        >
                                            <div
                                                class="showcase-slide-cover"
                                                :class="[
                                                    'c' + ((idx % 5) + 1),
                                                    { 'is-media': !!slide.mediaUrl }
                                                ]"
                                                :style="slide.coverStyle"
                                                @click="previewShowcase(slide)"
                                            >
                                                <img
                                                    v-if="slide.fileType === 'image' && slide.mediaUrl"
                                                    :src="slide.mediaUrl"
                                                    class="showcase-media"
                                                    alt=""
                                                />
                                                <video
                                                    v-else-if="slide.fileType === 'video' && slide.mediaUrl"
                                                    :src="slide.mediaUrl"
                                                    class="showcase-media"
                                                    controls
                                                    disablePictureInPicture
                                                    controlslist="nodownload"
                                                    :id="`phShowcaseVideo${idx}`"
                                                    @click.stop
                                                    @play="onShowcaseVideoPlay"
                                                    @pause="onShowcaseVideoPause"
                                                    @ended="onShowcaseVideoEnded"
                                                ></video>
                                                <div v-else class="cover-deco"></div>
                                                <span
                                                    v-if="slide.fileType === 'video' && !slide.mediaUrl"
                                                    class="cover-play"
                                                    aria-hidden="true"
                                                ></span>
                                            </div>
                                            <div class="showcase-slide-info">
                                                <div class="info-main">
                                                    <h4>{{ slide.title }}</h4>
                                                    <p>
                                                        <i class="el-icon-time"></i>
                                                        <span>{{ slide.desc }}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="showcase-dots" v-if="showcaseList.length > 1">
                                    <button
                                        v-for="(_, idx) in showcaseList"
                                        :key="idx"
                                        type="button"
                                        class="showcase-dot"
                                        :class="{ 'is-active': showcaseIndex === idx }"
                                        @click="setShowcaseIndex(idx)"
                                    ></button>
                                </div>
                            </div>
                            <button
                                v-if="showcaseList.length > 1"
                                type="button"
                                class="showcase-arrow next"
                                @click="nextShowcase"
                            >
                                <i class="el-icon-arrow-right"></i>
                            </button>
                        </div>
                        <ph-empty
                            v-else-if="!showcaseLoading"
                            size="panel"
                            text="暂无风采内容"
                        />
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import PhEmpty from './components/ph-empty.vue'
import BannerSwitchTab from '@/components/BannerSwitchTab.vue'
import pagination from '@/common/community/pagination.vue'
import {
    getWeekLabel,
    computeWeekOffsetBounds,
    clampWeekOffset,
    buildWeekDayEvents,
    fetchSpaceWeekSchedule,
    fetchProjectSchedulePeriod as requestProjectSchedulePeriod,
    pickWeekOffsetWithData
} from './schedule-data'
import {
    normalizeRegionLabel,
    mergeRegionFilterTabs,
    mergeProvinceMetricRows
} from './region-label'

export default {
    name: 'ProjectHome',
    components: { PhEmpty, pagination, BannerSwitchTab },
    data() {
        return {
            briefLoading: false,
            activeSpace: '',
            weekOffset: 0,
            activePair: 'all',
            showcaseIndex: 0,
            showcaseTimer: null,
            showcasePlaying: false,
            briefList: [],
            noticeList: [],
            noticeLoading: false,
            statsLoading: false,
            statsEmpty: true,
            statsBar: [
                { key: 'partnerSchoolCount', label: '结对空间', value: 0, unit: '个', icon: 'el-icon-s-home' },
                { key: 'partnerClassCount', label: '结对班级', value: 0, unit: '个', icon: 'el-icon-copy-document' },
                { key: 'courseCount', label: '课程总数', value: 0, unit: '节', icon: 'el-icon-video-play' },
                { key: 'homeworkSubmitCount', label: '作业提交', value: 0, unit: '份', icon: 'el-icon-s-order' },
                { key: 'gswRecordCount', label: '观思问记录', value: 0, unit: '条', icon: 'el-icon-view' }
            ],
            spaceTabsLoading: false,
            spaceTabs: [],
            spaceTabsCanScrollLeft: false,
            spaceTabsCanScrollRight: false,
            scheduleLoading: false,
            scheduleWeekDays: [],
            projectSchedulePeriod: null,
            scheduleFetchSeq: 0,
            schoolMetrics: [],
            peopleMetrics: [],
            provinceStatsLoading: false,
            pairFilters: [],
            spaceRegionLoading: false,
            spaceRegionEmpty: true,
            spaceListLoading: false,
            spaceRows: [],
            spaceListPages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            courseLoading: false,
            courseList: [],
            classListLoading: false,
            classRows: [],
            classListPages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            showcaseLoading: false,
            showcaseList: []
        }
    },
    computed: {
        ...mapState({
            currentProject: state => state.user.currentProject,
            role: state => state.user.role,
            userInfo: state => state.user.userInfo
        }),
        projectModelType() {
            return Number(this.currentProject && this.currentProject.modelType)
        },
        canFetchStats() {
            return [4, 5, 6, 9].includes(this.projectModelType)
        },
        noticeDay() {
            return dayjs().format('DD')
        },
        noticeMd() {
            return `${dayjs().format('MMM')} ${dayjs().format('YYYY')}`
        },
        weekLabel() {
            return getWeekLabel(this.weekOffset)
        },
        scheduleOffsetBounds() {
            return computeWeekOffsetBounds(this.projectSchedulePeriod)
        },
        canSchedulePrev() {
            const b = this.scheduleOffsetBounds
            if (!b) return true
            return this.weekOffset > b.minOffset
        },
        canScheduleNext() {
            const b = this.scheduleOffsetBounds
            if (!b) return true
            return this.weekOffset < b.maxOffset
        },
        currentWeekDays() {
            if (this.scheduleWeekDays.length) return this.scheduleWeekDays
            return buildWeekDayEvents({
                weekOffset: this.weekOffset,
                onlineMap: {},
                offlineMap: {},
                publishedMap: {},
                resourceMap: {}
            })
        },
        activePairProvinceIds() {
            const tab = this.pairFilters.find(item => item.key === this.activePair)
            return (tab && tab.provinceIds) || []
        }
    },
    methods: {
        eventTypeLabel(typeClass) {
            if (typeClass === 'ev-live') return '录播'
            if (typeClass === 'ev-offline') return '线下'
            return '直播'
        },
        stripHtmlText(val) {
            if (!val) return ''
            return String(val)
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&')
                .replace(/&lt;/gi, '<')
                .replace(/&gt;/gi, '>')
                .replace(/\uFFFD/g, '')
                .replace(/[\uE000-\uF8FF]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        cleanNoticeTitle(title) {
            return this.stripHtmlText(title)
        },
        eventTimeOnly(time) {
            if (!time) return ''
            return String(time).split('·')[0].trim()
        },
        formatBriefDate(val) {
            if (!val) return '--'
            return dayjs(val).format('YYYY-MM-DD')
        },
        goBriefList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/brief`)
        },
        goBriefPreview(item) {
            if (!item || !item.identifier) {
                this.$message.error('暂无内容')
                return
            }
            this.$router.push({
                path: `/projectHome/${this.$route.params.id}/brief/preview`,
                query: {
                    identifier: item.identifier,
                    name: item.name || '',
                    date: this.formatBriefDate(item.createTime),
                    from: 'home'
                }
            })
        },
        goNoticeList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/notice`)
        },
        goNoticeDetail(item) {
            if (!item || !item.id) {
                this.$message.error('暂无内容')
                return
            }
            this.$router.push({
                path: `/projectHome/${this.$route.params.id}/notice/${item.id}`,
                query: { from: 'home' }
            })
        },
        goScheduleList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/schedule`)
        },
        goSpaceStatsList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/space-stats`)
        },
        goCoursesList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/courses`)
        },
        getCourseSourceBadge(createSourceType) {
            const map = {
                1: '校级',
                3: '结对班级',
                4: '研伴',
                5: '两级工作室'
            }
            return map[createSourceType] || ''
        },
        resolveCourseCover(cover) {
            if (!cover) return ''
            if (cover.startsWith('http://') || cover.startsWith('https://') || cover.startsWith('//')) {
                return cover
            }
            return `${this.downloadURL}${cover}`
        },
        mapCourseItem(item) {
            const cover = this.resolveCourseCover(item && item.cover)
            const tags = []
            if (item.spxName) tags.push(item.spxName)
            const rawIntro = (item && (
                item.courseExplain
                || item.introduction
                || item.courseIntro
                || item.description
                || item.remark
            )) || ''
            return {
                id: item.courseId,
                title: item.courseName || '未命名课程',
                desc: this.stripHtmlText(rawIntro),
                tags,
                badge: '',
                coverStyle: cover
                    ? {
                        backgroundImage: `linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.35)), url(${cover})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }
                    : ''
            }
        },
        async fetchCourseList() {
            const projectId = this.$route.params.id
            if (!projectId) {
                this.courseList = []
                return
            }
            this.courseLoading = true
            try {
                const res = await this.$Api.Paired.getSharedCourses({
                    page: 1,
                    limit: 4,
                    projectId
                })
                const list = (res && res.data && res.data.records) || []
                this.courseList = list.map(item => this.mapCourseItem(item))
            } catch (e) {
                this.courseList = []
            } finally {
                this.courseLoading = false
            }
        },
        toCourseDetail(item, index) {
            if (!item || !item.id) return
            this.$router.push({
                path: `/course/${item.id}`,
                query: {
                    proid: this.$route.params.id,
                    index
                }
            })
        },
        goClassStatsList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/class-stats`)
        },
        goShowcaseList() {
            this.$router.push(`/projectHome/${this.$route.params.id}/showcase`)
        },
        toStatNumber(val) {
            const n = Number(val)
            return Number.isFinite(n) ? n : 0
        },
        resetStatsEmpty() {
            this.statsEmpty = true
            this.statsBar = this.statsBar.map(item => ({ ...item, value: 0 }))
        },
        async fetchProjectStats() {
            const projectId = this.$route.params.id
            if (!projectId || !this.canFetchStats) {
                this.resetStatsEmpty()
                return
            }
            this.statsLoading = true
            try {
                const res = await this.$Api.Paired.getProjectStats({ projectId })
                const data = (res && res.data) || null
                if (!data || typeof data !== 'object') {
                    this.resetStatsEmpty()
                    return
                }
                this.statsBar = this.statsBar.map(item => ({
                    ...item,
                    value: this.toStatNumber(data[item.key])
                }))
                this.statsEmpty = this.statsBar.every(item => item.value <= 0)
            } catch (e) {
                this.resetStatsEmpty()
            } finally {
                this.statsLoading = false
            }
        },
        formatCount(val) {
            const n = this.toStatNumber(val)
            return n.toLocaleString('zh-CN')
        },
        mapProvinceMetricList(list, unit) {
            return mergeProvinceMetricRows(list, {
                unit,
                toNumber: this.toStatNumber,
                formatCount: this.formatCount
            })
        },
        async fetchProvinceStats() {
            const projectId = this.$route.params.id
            if (!projectId || !this.canFetchStats) {
                this.schoolMetrics = []
                this.peopleMetrics = []
                return
            }
            this.provinceStatsLoading = true
            try {
                const res = await this.$Api.Paired.getProjectProvinceStats({ projectId })
                const data = (res && res.data) || {}
                this.schoolMetrics = this.mapProvinceMetricList(data.schoolCountList, '所')
                this.peopleMetrics = this.mapProvinceMetricList(data.participantCountList, '人')
            } catch (e) {
                this.schoolMetrics = []
                this.peopleMetrics = []
            } finally {
                this.provinceStatsLoading = false
            }
        },
        mapSchoolSpaceRow(item) {
            return {
                spaceId: item.spaceId,
                name: item.spaceName || '',
                regionLabel: normalizeRegionLabel(item.regionLabel || '') || (item.regionLabel || ''),
                provinceIds: item.provinceIds || [],
                partners: item.schoolNames || '',
                classes: this.toStatNumber(item.classSpaceCount),
                members: this.toStatNumber(item.memberCount),
                courses: this.toStatNumber(item.courseCount),
                works: this.toStatNumber(item.homeworkCount),
                gsw: this.toStatNumber(item.gswCount),
                resources: this.toStatNumber(item.resourceCount)
            }
        },
        resetSpaceRegionEmpty() {
            this.spaceRegionEmpty = true
            this.pairFilters = []
            this.activePair = 'all'
            this.spaceRows = []
            this.spaceListPages.total = 0
            this.spaceListPages.currentPage = 1
        },
        async fetchSpaceRegionStats() {
            const projectId = this.$route.params.id
            if (!projectId || !this.canFetchStats) {
                this.resetSpaceRegionEmpty()
                return
            }
            this.spaceRegionLoading = true
            try {
                const res = await this.$Api.Paired.getProjectSpaceRegionStats({ projectId })
                const data = (res && res.data) || {}
                const list = Array.isArray(data.list) ? data.list : []
                const total = this.toStatNumber(data.total)
                if (total <= 0 && list.length === 0) {
                    this.resetSpaceRegionEmpty()
                    return
                }
                this.pairFilters = [
                    {
                        key: 'all',
                        name: '全部',
                        count: total,
                        provinceIds: []
                    },
                    ...mergeRegionFilterTabs(list, this.toStatNumber)
                ]
                this.spaceRegionEmpty = false
                if (!this.pairFilters.some(item => item.key === this.activePair)) {
                    this.activePair = 'all'
                }
                this.spaceListPages.currentPage = 1
                await this.fetchSchoolSpaces()
            } catch (e) {
                this.resetSpaceRegionEmpty()
            } finally {
                this.spaceRegionLoading = false
            }
        },
        async fetchSchoolSpaces() {
            const projectId = this.$route.params.id
            if (!projectId || !this.canFetchStats || this.spaceRegionEmpty) {
                this.spaceRows = []
                this.spaceListPages.total = 0
                return
            }
            this.spaceListLoading = true
            const activeTab = this.pairFilters.find(item => item.key === this.activePair)
            const regionLabel = activeTab && activeTab.key !== 'all' ? activeTab.name : ''
            try {
                // 非「全部」时优先按 regionLabel 过滤：
                // 后端 provinceIds 精确匹配当前联调不稳定（Tab 有数、列表为空）
                if (regionLabel) {
                    const allTotal = this.toStatNumber(
                        (this.pairFilters.find(item => item.key === 'all') || {}).count
                    )
                    const provinceIds = (this.activePairProvinceIds || [])
                        .map(id => Number(id))
                        .filter(id => Number.isFinite(id))
                    let records = []
                    // 先带 provinceIds 试一次
                    if (provinceIds.length) {
                        const res = await this.$Api.Paired.getProjectSchoolSpaces({
                            projectId,
                            page: this.spaceListPages.currentPage,
                            limit: this.spaceListPages.pageSize,
                            provinceIds
                        })
                        records = ((res && res.data && res.data.records) || [])
                        const total = this.toStatNumber(res && res.data && res.data.total)
                        if (records.length || total > 0) {
                            this.spaceRows = records.map(item => this.mapSchoolSpaceRow(item))
                            this.spaceListPages.total = total
                            return
                        }
                    }
                    // 兜底：拉全部后按省区标签筛选再分页
                    const fb = await this.$Api.Paired.getProjectSchoolSpaces({
                        projectId,
                        page: 1,
                        limit: Math.max(allTotal, this.spaceListPages.pageSize, 50)
                    })
                    const matched = ((fb && fb.data && fb.data.records) || [])
                        .filter(item => {
                            const label = normalizeRegionLabel(item.regionLabel || '') || (item.regionLabel || '')
                            return label === regionLabel
                        })
                    const start = (this.spaceListPages.currentPage - 1) * this.spaceListPages.pageSize
                    this.spaceRows = matched
                        .slice(start, start + this.spaceListPages.pageSize)
                        .map(item => this.mapSchoolSpaceRow(item))
                    this.spaceListPages.total = matched.length
                    return
                }

                const res = await this.$Api.Paired.getProjectSchoolSpaces({
                    projectId,
                    page: this.spaceListPages.currentPage,
                    limit: this.spaceListPages.pageSize
                })
                const data = (res && res.data) || {}
                this.spaceRows = (data.records || []).map(item => this.mapSchoolSpaceRow(item))
                this.spaceListPages.total = this.toStatNumber(data.total)
            } catch (e) {
                this.spaceRows = []
                this.spaceListPages.total = 0
            } finally {
                this.spaceListLoading = false
            }
        },
        onPairFilterChange(key) {
            if (this.activePair === key) return
            this.activePair = key
            this.spaceListPages.currentPage = 1
            this.fetchSchoolSpaces()
        },
        handleSpacePageChange(data) {
            this.spaceListPages.currentPage = data.pageIndex
            this.spaceListPages.pageSize = data.pageSize
            this.fetchSchoolSpaces()
        },
        formatPairingClass(val) {
            if (!val) return '--'
            return String(val)
        },
        mapClassSpaceRow(item) {
            return {
                spaceId: item.spaceId,
                name: this.formatPairingClass(item.pairingClass),
                space: item.parentSpaceName || '',
                members: this.toStatNumber(item.memberCount),
                courses: this.toStatNumber(item.courseCount),
                works: this.toStatNumber(item.homeworkCount),
                gsw: this.toStatNumber(item.gswCount),
                results: this.toStatNumber(item.resourceCount)
            }
        },
        async fetchClassSpaces() {
            const projectId = this.$route.params.id
            if (!projectId || !this.canFetchStats) {
                this.classRows = []
                this.classListPages.total = 0
                return
            }
            this.classListLoading = true
            try {
                const res = await this.$Api.Paired.getProjectClassSpaces({
                    projectId,
                    page: this.classListPages.currentPage,
                    limit: this.classListPages.pageSize
                })
                const data = (res && res.data) || {}
                this.classRows = (data.records || []).map(item => this.mapClassSpaceRow(item))
                this.classListPages.total = this.toStatNumber(data.total)
            } catch (e) {
                this.classRows = []
                this.classListPages.total = 0
            } finally {
                this.classListLoading = false
            }
        },
        handleClassPageChange(data) {
            this.classListPages.currentPage = data.pageIndex
            this.classListPages.pageSize = data.pageSize
            this.fetchClassSpaces()
        },
        async fetchBriefList() {
            const projectId = this.$route.params.id
            if (!projectId) {
                this.briefList = []
                return
            }
            this.briefLoading = true
            try {
                const res = await this.$Api.Project.getProjectBriefing({
                    projectId,
                    page: 1,
                    limit: 5
                })
                const records = (res && res.data && res.data.records) || []
                this.briefList = records
            } catch (e) {
                this.briefList = []
            } finally {
                this.briefLoading = false
            }
        },
        formatNoticeDate(val) {
            if (!val) return '--'
            return dayjs(val).format('YYYY-MM-DD')
        },
        mapNoticeItem(item) {
            return {
                id: item.id,
                title: this.cleanNoticeTitle(item.title || ''),
                date: this.formatNoticeDate(item.updateTime || item.createTime),
                summary: item.introduction || '',
                org: item.source || item.author || ''
            }
        },
        async fetchNoticeList() {
            const projectId = this.$route.params.id
            if (!projectId) {
                this.noticeList = []
                return
            }
            this.noticeLoading = true
            try {
                const res = await this.$Api.Home.getNewsListByProjectId({
                    projectId,
                    page: 1,
                    limit: 6
                })
                const list = (res && res.data && res.data.list) || []
                this.noticeList = list.map(item => this.mapNoticeItem(item))
            } catch (e) {
                this.noticeList = []
            } finally {
                this.noticeLoading = false
            }
        },
        shiftWeek(delta) {
            const next = clampWeekOffset(this.weekOffset + delta, this.scheduleOffsetBounds)
            if (next === this.weekOffset) return
            this.weekOffset = next
            this.fetchSpaceSchedule({ allowAutoJump: false })
        },
        selectSpaceTab(key) {
            if (this.activeSpace === key) return
            this.activeSpace = key
            this.$nextTick(() => this.scrollActiveSpaceTabIntoView())
            this.fetchSpaceSchedule({ allowAutoJump: false })
        },
        updateSpaceTabsScrollState() {
            const el = this.$refs.spaceTabsScroll
            if (!el) {
                this.spaceTabsCanScrollLeft = false
                this.spaceTabsCanScrollRight = false
                return
            }
            const maxScroll = el.scrollWidth - el.clientWidth
            this.spaceTabsCanScrollLeft = el.scrollLeft > 2
            this.spaceTabsCanScrollRight = maxScroll - el.scrollLeft > 2
        },
        scrollSpaceTabs(direction) {
            const el = this.$refs.spaceTabsScroll
            if (!el) return
            const step = Math.max(Math.floor(el.clientWidth * 0.6), 160)
            el.scrollBy({ left: direction * step, behavior: 'smooth' })
        },
        scrollActiveSpaceTabIntoView() {
            const wrap = this.$refs.spaceTabsScroll
            if (!wrap) return
            const active = wrap.querySelector('.region-btn.is-active')
            if (active && typeof active.scrollIntoView === 'function') {
                active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' })
            }
            this.updateSpaceTabsScrollState()
        },
        async loadProjectSchedulePeriod() {
            const projectId = this.$route.params.id || (this.currentProject && this.currentProject.id)
            if (!projectId) {
                this.projectSchedulePeriod = null
                return
            }
            this.projectSchedulePeriod = await requestProjectSchedulePeriod(this.$Api.Paired, projectId)
            const next = clampWeekOffset(this.weekOffset, this.scheduleOffsetBounds)
            if (next !== this.weekOffset) this.weekOffset = next
        },
        async fetchSpaceSchedule(options = {}) {
            const allowAutoJump = options.allowAutoJump === true
            const projectId = this.$route.params.id || (this.currentProject && this.currentProject.id)
            const spaceId = this.activeSpace
            const userId = this.userInfo && this.userInfo.id
            if (!projectId || !spaceId) {
                this.scheduleWeekDays = buildWeekDayEvents({
                    weekOffset: this.weekOffset,
                    onlineMap: {},
                    offlineMap: {},
                    publishedMap: {},
                    resourceMap: {}
                })
                return
            }
            const seq = ++this.scheduleFetchSeq
            this.scheduleLoading = true
            try {
                const data = await fetchSpaceWeekSchedule(this.$Api.Paired, {
                    projectId,
                    spaceId,
                    userId,
                    weekOffset: this.weekOffset
                })
                if (seq !== this.scheduleFetchSeq) return
                let useData = data
                if (allowAutoJump) {
                    const nextOffset = pickWeekOffsetWithData({
                        onlineMap: data.onlineMap,
                        offlineMap: data.offlineMap,
                        publishedMap: data.publishedMap,
                        bounds: this.scheduleOffsetBounds,
                        currentOffset: this.weekOffset
                    })
                    if (nextOffset !== this.weekOffset) {
                        this.weekOffset = nextOffset
                        useData = await fetchSpaceWeekSchedule(this.$Api.Paired, {
                            projectId,
                            spaceId,
                            userId,
                            weekOffset: this.weekOffset
                        })
                        if (seq !== this.scheduleFetchSeq) return
                    }
                }
                this.scheduleWeekDays = buildWeekDayEvents({
                    weekOffset: this.weekOffset,
                    onlineMap: useData.onlineMap,
                    offlineMap: useData.offlineMap,
                    publishedMap: useData.publishedMap,
                    resourceMap: useData.resourceMap
                })
            } catch (e) {
                if (seq !== this.scheduleFetchSeq) return
                this.scheduleWeekDays = buildWeekDayEvents({
                    weekOffset: this.weekOffset,
                    onlineMap: {},
                    offlineMap: {},
                    publishedMap: {},
                    resourceMap: {}
                })
            } finally {
                if (seq === this.scheduleFetchSeq) this.scheduleLoading = false
            }
        },
        async fetchSpaceTabs() {
            const projectId = this.$route.params.id || (this.currentProject && this.currentProject.id)
            if (!projectId) {
                this.spaceTabs = []
                this.activeSpace = ''
                this.spaceTabsCanScrollLeft = false
                this.spaceTabsCanScrollRight = false
                this.scheduleWeekDays = []
                return
            }
            this.spaceTabsLoading = true
            try {
                const res = await this.$Api.Paired.getProjectSchoolSpacesAll({ projectId })
                const raw = (res && res.data) || []
                const records = Array.isArray(raw) ? raw : (raw.records || [])
                this.spaceTabs = records.map(item => {
                    const id = item.spaceId ?? item.id
                    return {
                        key: String(id),
                        id,
                        name: item.spaceName || item.spxName || '未命名空间'
                    }
                })
                if (!this.spaceTabs.find(tab => tab.key === this.activeSpace)) {
                    this.activeSpace = this.spaceTabs.length ? this.spaceTabs[0].key : ''
                }
                this.$nextTick(() => {
                    this.updateSpaceTabsScrollState()
                    this.scrollActiveSpaceTabIntoView()
                })
                await this.fetchSpaceSchedule({ allowAutoJump: false })
            } catch (e) {
                this.spaceTabs = []
                this.activeSpace = ''
                this.scheduleWeekDays = []
            } finally {
                this.spaceTabsLoading = false
            }
        },
        getFileTypeByIdentifier(identifier) {
            if (!identifier) return 'video'
            const fileName = String(identifier).split('?')[0].toLowerCase()
            let suffix = ''
            if (fileName.includes('_')) {
                const parts = fileName.split('_')
                suffix = parts[parts.length - 1]
            } else if (fileName.includes('.')) {
                suffix = fileName.slice(fileName.lastIndexOf('.') + 1)
            } else {
                suffix = fileName
            }
            const imageSuffixList = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']
            return imageSuffixList.includes(suffix) ? 'image' : 'video'
        },
        mapShowcaseItem(item, idx) {
            const fileType = this.getFileTypeByIdentifier(item.identifier)
            const mediaUrl = item.identifier ? `${this.downloadURL}${item.identifier}` : ''
            return {
                id: item.id || `showcase-${idx}`,
                title: item.name || '未命名成果',
                desc: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '--',
                tag: fileType === 'image' ? '回顾 · 图片' : '回顾 · 视频',
                fileType,
                identifier: item.identifier || '',
                mediaUrl,
                coverStyle: fileType === 'image' && mediaUrl
                    ? { backgroundImage: `url(${mediaUrl})` }
                    : ''
            }
        },
        async fetchShowcaseList() {
            const projectId = this.$route.params.id
            if (!projectId) {
                this.showcaseList = []
                return
            }
            this.showcaseLoading = true
            try {
                const res = await this.$Api.Project.getProjectFile({ projectId })
                const list = (res && res.data && res.data['项目回顾']) || []
                this.showcaseList = list.map((item, idx) => this.mapShowcaseItem(item, idx))
                if (this.showcaseIndex >= this.showcaseList.length) {
                    this.showcaseIndex = 0
                }
                if (this.showcaseList.length) {
                    this.startShowcaseAuto()
                } else {
                    this.stopShowcaseAuto()
                }
            } catch (e) {
                this.showcaseList = []
                this.stopShowcaseAuto()
            } finally {
                this.showcaseLoading = false
            }
        },
        previewShowcase(item) {
            if (!item || !item.identifier) {
                this.$message.error('暂无内容')
                return
            }
            if (item.fileType === 'image') {
                const imageList = this.showcaseList
                    .filter(row => row.fileType === 'image' && row.mediaUrl)
                    .map(row => row.mediaUrl)
                if (!imageList.length) return
                const currentIndex = imageList.findIndex(url => url === item.mediaUrl)
                this.$previewImgs(imageList, currentIndex > -1 ? currentIndex : 0)
                return
            }
            this.stopShowcaseAuto()
            const idx = this.showcaseList.findIndex(row => row.id === item.id)
            if (idx > -1) this.showcaseIndex = idx
            this.$nextTick(() => {
                const video = document.getElementById(`phShowcaseVideo${this.showcaseIndex}`)
                if (video && typeof video.play === 'function') {
                    video.play()
                }
            })
        },
        pauseShowcaseVideo(index) {
            const video = document.getElementById(`phShowcaseVideo${index}`)
            if (video && typeof video.pause === 'function') {
                video.pause()
            }
        },
        onShowcaseVideoPlay() {
            this.showcasePlaying = true
            this.stopShowcaseAuto()
        },
        onShowcaseVideoPause() {
            this.showcasePlaying = false
            this.startShowcaseAuto()
        },
        onShowcaseVideoEnded() {
            this.showcasePlaying = false
            this.startShowcaseAuto()
        },
        setShowcaseIndex(idx) {
            if (idx === this.showcaseIndex) return
            this.pauseShowcaseVideo(this.showcaseIndex)
            this.showcasePlaying = false
            this.showcaseIndex = idx
            this.startShowcaseAuto()
        },
        prevShowcase() {
            const len = this.showcaseList.length
            if (!len) return
            this.pauseShowcaseVideo(this.showcaseIndex)
            this.showcasePlaying = false
            this.showcaseIndex = (this.showcaseIndex - 1 + len) % len
            this.startShowcaseAuto()
        },
        nextShowcase() {
            const len = this.showcaseList.length
            if (!len) return
            this.pauseShowcaseVideo(this.showcaseIndex)
            this.showcasePlaying = false
            this.showcaseIndex = (this.showcaseIndex + 1) % len
            this.startShowcaseAuto()
        },
        startShowcaseAuto() {
            this.stopShowcaseAuto()
            if (this.showcaseList.length <= 1 || this.showcasePlaying) return
            this.showcaseTimer = setInterval(() => {
                if (this.showcasePlaying) return
                this.nextShowcase()
            }, 5000)
        },
        stopShowcaseAuto() {
            if (this.showcaseTimer) {
                clearInterval(this.showcaseTimer)
                this.showcaseTimer = null
            }
        },
        // 新型项目直接放行；非新型无通知公告则拦截
        async ensureHasMainPage() {
            const projectId = this.$route.params.id
            let modelType = Number(this.currentProject && this.currentProject.modelType)
            // 刷新时 vuex 可能没有项目类型，先补 selectDetail
            if (!Number.isFinite(modelType) || modelType === 0) {
                try {
                    const res = await this.$Api.Paired.getProjectDetailTime({ projectId })
                    const detail = (res && res.data) || {}
                    modelType = Number(detail.modelType)
                    if (Number.isFinite(modelType) && modelType !== 0) {
                        this.$store.commit('getCurrentProject', {
                            ...(this.currentProject || {}),
                            ...detail,
                            id: detail.id || projectId
                        })
                    }
                } catch (e) {
                    /* ignore */
                }
            }
            if ([4, 5, 6, 9].includes(modelType)) {
                this.$store.commit('getHasMain', true)
                return true
            }

            let hasMain = false
            try {
                const res = await this.$Api.Home.getNewsListByProjectId({
                    projectId,
                    page: 1,
                    limit: 4
                })
                const list = (res && res.data && res.data.list) || []
                hasMain = Array.isArray(list) && list.length > 0
            } catch (e) {
                hasMain = false
            }
            this.$store.commit('getHasMain', hasMain)
            if (hasMain) return true
            this.$message({
                duration: 1000,
                message: '该项目暂无项目主页',
                type: 'error'
            })
            const pid = Number((this.currentProject && this.currentProject.id) || projectId)
            const teacherSpecialIds = [735, 759, 762, 765]
            const ignoreProjectIds = [735, 759, 762, 765, 772, 775, 778, 781, 784, 787, 791]
            const managerPath = ignoreProjectIds.includes(pid) ? '/home/totalWork' : '/home/totalCourse'
            const pathMap = {
                parent: '/home/schedule',
                normal: '/home/schedule',
                teacher: teacherSpecialIds.includes(pid) ? '/home/mytask' : '/home/schedule',
                student: '/home/schedule',
                expert: '/home/schedule',
                assistant: '/home/schedule',
                school: '/home/leader_home',
                leader: '/home/leader_home',
                manager: managerPath,
                'bc-manager': managerPath
            }
            this.$router.replace(pathMap[this.role] || '/home/weekly')
            return false
        }
    },
    async mounted() {
        const ok = await this.ensureHasMainPage()
        if (!ok) return
        this.weekOffset = 0
        this.fetchBriefList()
        this.fetchNoticeList()
        this.fetchProjectStats()
        this.fetchProvinceStats()
        this.fetchSpaceRegionStats()
        this.fetchClassSpaces()
        this.fetchCourseList()
        this.fetchShowcaseList()
        this.loadProjectSchedulePeriod().then(() => this.fetchSpaceTabs())
        this._onSpaceTabsResize = () => this.updateSpaceTabsScrollState()
        window.addEventListener('resize', this._onSpaceTabsResize)
    },
    watch: {
        'currentProject.modelType'() {
            this.fetchProjectStats()
            this.fetchProvinceStats()
            this.fetchSpaceRegionStats()
            this.fetchClassSpaces()
        },
        '$route.params.id': async function () {
            const ok = await this.ensureHasMainPage()
            if (!ok) return
            this.weekOffset = 0
            this.fetchBriefList()
            this.fetchNoticeList()
            this.fetchProjectStats()
            this.fetchProvinceStats()
            this.fetchSpaceRegionStats()
            this.fetchClassSpaces()
            this.fetchCourseList()
            this.fetchShowcaseList()
            this.loadProjectSchedulePeriod().then(() => this.fetchSpaceTabs())
        }
    },
    beforeDestroy() {
        this.stopShowcaseAuto()
        if (this._onSpaceTabsResize) {
            window.removeEventListener('resize', this._onSpaceTabsResize)
        }
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: 'ktf';
    src: url("../../../static/font/ktf.TTF");
}

.project-home {
    --primary: #01A2FD;
    --primary-dark: #1769FA;
    --primary-light: #EAF6FF;
    --text: #333;
    --text-secondary: #666;
    --text-muted: #999;
    --bg: #fff;
    --card: #fff;
    --border: rgba(199, 199, 199, 0.4);
    --radius: 12px;
    background: var(--bg);
    line-height: 1;
    min-height: 60vh;
    color: var(--text);
}

.banner-wrapper {
    background-color: #1769FA;
    position: relative;

    /deep/ .el-carousel__container {
        height: 430px;
    }

    .default-banner {
        width: 100%;
        height: 100%;
        text-align: center;
        color: #fff;
        background-image: url("~@/assets/images/main/banner.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }

    .banner-inner {
        padding: 0 24px;
    }

    .banner-title {
        margin-top: 120px;
        font-size: 50px;
        margin-bottom: 43px;
        font-family: 'ktf', "Microsoft YaHei", sans-serif;
        line-height: 1.2;
        padding: 0 40px;
    }

    .banner-subtitle {
        font-size: 17px;
        margin: 0 auto;
        width: 990px;
        max-width: 90%;
        line-height: 1.5;
        opacity: 0.95;
    }
}

.ph-main {
    padding: 50px 0 60px;
}

.ph-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
}

.section-card {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
    margin-bottom: 25px;
    box-shadow: none;
}

.section-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    line-height: 56px;
    background-color: rgba(250, 251, 255, 1);
    border-bottom: 1px solid var(--border);

    h3 {
        font-size: 16px;
        font-weight: 400;
        color: var(--text);
        display: flex;
        align-items: center;
        margin: 0;

        &::before {
            content: "";
            width: 3px;
            height: 16px;
            background: #01A2FD;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
}

.brief-card .section-hd h3::before {
    display: none;
}

.brief-icon {
    display: inline-block;
    width: 21px;
    height: 21px;
    background-image: url("~@/assets/images/main/bulltin-icon.png");
    background-size: 100% 100%;
    margin-right: 12px;
    vertical-align: -4px;
    flex-shrink: 0;
}

.more-link {
    font-size: 13px;
    color: #999;
    text-decoration: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: none;
    padding: 0;
    font-family: inherit;
    line-height: 1;

    i {
        font-size: 12px;
        margin-left: 2px;
    }

    &:hover {
        color: #01A2FD;
    }
}

.row-top {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 33px;
    margin-bottom: 25px;
    align-items: stretch;
}

.left-col,
.right-col {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.left-col .section-card {
    flex: 1;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
}

.news-list {
    list-style: none;
    margin: 0;
    padding: 8px 30px 16px;
    min-height: 300px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.news-item {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 56px;
    border-bottom: 1px solid var(--border);
    text-decoration: none;
    color: inherit;
    padding: 0;

    &:last-child {
        border-bottom: 0;
    }

    &:hover .news-title {
        color: #01A2FD;
    }
}

.news-title {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.4;

    .dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        background-color: #01A2FD;
        border-radius: 50%;
        vertical-align: 2px;
        margin-right: 14px;
    }
}

.news-tag {
    flex-shrink: 0;
    font-size: 11px;
    color: #01A2FD;
    background: #EAF6FF;
    border: 1px solid rgba(1, 162, 253, 0.35);
    border-radius: 2px;
    padding: 0 6px;
    line-height: 18px;
}

.news-date {
    flex-shrink: 0;
    width: 88px;
    text-align: right;
    font-size: 12px;
    color: #999;
}

.brief-empty-item {
    list-style: none;
    padding: 0;
    border-bottom: none;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
}

.notice-block {
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
    height: 100%;
}

.notice-banner {
    background: linear-gradient(135deg, #01A2FD 0%, #1769FA 100%);
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 56px;
    box-sizing: border-box;
    padding: 0 16px;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.1);
        top: -36px;
        left: -20px;
    }

    &::after {
        content: "";
        position: absolute;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);
        bottom: -24px;
        right: -12px;
    }
}

.notice-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    position: relative;
    z-index: 1;
}

.notice-banner-title {
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 3px;
    position: relative;
    z-index: 1;
}

.notice-more {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 13px;
    text-decoration: none;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: none;
    padding: 0;
    font-family: inherit;
    cursor: pointer;
    line-height: 1;

    i {
        font-size: 12px;
        margin-left: 2px;
    }
}

.notice-body {
    display: flex;
    flex-direction: column;
    padding: 0;
    flex: 1;
    box-sizing: border-box;
    min-height: 240px;

    &.is-empty {
        align-items: center;
        justify-content: center;
    }
}

.notice-date {
    display: flex;
    align-items: baseline;
    gap: 10px;
    padding: 16px 18px 14px;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;

    .day {
        font-size: 32px;
        font-weight: 500;
        color: #1769FA;
        line-height: 1;
    }

    .md {
        font-size: 14px;
        color: #999;
        line-height: 1.2;
    }
}

.notice-list {
    display: flex;
    flex-direction: column;
    padding: 8px 18px 12px;
    flex: 1;

    a {
        font-size: 13px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        text-decoration: none;
        padding: 8px 0;
        border-bottom: none;

        &:hover .notice-item-title {
            color: #01A2FD;
        }
    }
}

.notice-item-title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.4;

    .dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        background-color: #01A2FD;
        border-radius: 50%;
        vertical-align: 2px;
        margin-right: 10px;
    }
}

.notice-item-date {
    flex-shrink: 0;
    font-size: 12px;
    color: #999;
}

.stats-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 96px;
    padding: 0 16px;
    margin-bottom: 25px;
    height: 112px;
    box-sizing: border-box;
    background-image: url("~@/assets/images/main/result-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 0;
    flex-wrap: wrap;
    color: #fff;
}

.stats-empty-wrap {
    margin-bottom: 25px;
    min-height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-sizing: border-box;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: none;
    background: #fff;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1769FA;
    font-size: 22px;
    flex-shrink: 0;
}

.stat-num {
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    line-height: 1.1;
    width: auto;
    text-align: left;

    small {
        font-size: 14px;
        font-weight: 500;
        margin-left: 2px;
    }
}

.stat-label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.82);
    font-weight: 700;
    margin-top: 6px;
    text-align: left;
    line-height: 1.2;
}

.region-filter {
    display: flex;
    align-items: center;
    padding: 0 18px;
    border-bottom: 1px solid var(--border);
    flex-wrap: wrap;
}

.region-filter-btns {
    display: flex;
    gap: 0;
    flex-wrap: wrap;
}

.region-btn {
    padding: 16px 14px;
    font-size: 13px;
    color: #666;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    white-space: nowrap;

    &:hover,
    &.is-active {
        color: #01A2FD;
    }

    &.is-active {
        font-weight: 400;

        &::after {
            content: "";
            position: absolute;
            left: 10px;
            right: 10px;
            bottom: 0;
            height: 2px;
            background: #01A2FD;
            border-radius: 1px;
        }
    }

    .count {
        margin-left: 2px;
        opacity: 0.75;
    }
}

.schedule-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 20px 6px;
}

.week-toolbar-left {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.week-toolbar-right {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.week-this-tag {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 4px;
    background: #1769FA;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
}

.week-nav {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #01A2FD;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: none;

    i {
        font-size: 14px;
        font-weight: 600;
    }

    &:hover {
        color: #1769FA;
        background: rgba(1, 162, 253, 0.08);
    }

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
        background: transparent;
    }
}

.week-chip-label {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    line-height: 1.2;
}

.week-chip-range {
    font-size: 13px;
    color: #666;
    font-weight: 400;
    letter-spacing: 0.2px;
    white-space: nowrap;
    min-width: 120px;
    text-align: center;
}

.schedule-body {
    padding: 16px 24px 8px;
}

.schedule-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
}

.schedule-day {
    background: #fff;
    border: 1px solid #eef2f7;
    border-radius: 10px;
    min-height: 420px;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;

    &.has-event {
        border-color: rgba(1, 162, 253, 0.2);
        box-shadow: 0 4px 14px rgba(23, 105, 250, 0.06);
    }

    &.is-weekend {
        background: #fafbfd;
    }
}

.schedule-day-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 10px 8px;
    background: linear-gradient(180deg, #f7faff 0%, #fff 100%);
    border-bottom: 1px solid #f0f3f7;

    .day-label {
        font-size: 12px;
        color: #8a94a6;
    }

    .day-num {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 1;
        font-variant-numeric: tabular-nums;
    }
}

.schedule-day.is-weekend .schedule-day-head {
    background: linear-gradient(180deg, #f5f6f8 0%, #fafbfd 100%);

    .day-num {
        color: #999;
    }
}

.schedule-day-body {
    flex: 1;
    min-height: 0;
    max-height: 280px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: rgba(1, 162, 253, 0.35) transparent;

    &.is-home {
        max-height: 420px;
    }

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        margin: 4px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(1, 162, 253, 0.28);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(1, 162, 253, 0.5);
    }
}

.schedule-event {
    background: linear-gradient(135deg, #EAF6FF 0%, #f5fbff 100%);
    color: #1769FA;
    border: 1px solid rgba(1, 162, 253, 0.18);
    border-left: 3px solid #01A2FD;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    line-height: 1.4;
    min-height: 78px;
    flex-shrink: 0;
    box-sizing: border-box;
    overflow: hidden;
    transition: transform 0.15s, box-shadow 0.15s;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 10px rgba(1, 162, 253, 0.12);
    }

    &.ev-live {
        background: linear-gradient(135deg, #e8f5e9 0%, #f4fbf5 100%);
        color: #2e7d32;
        border-color: rgba(46, 125, 50, 0.18);
        border-left-color: #2e7d32;

        .ev-badge {
            background: rgba(46, 125, 50, 0.12);
            color: #2e7d32;
        }
    }

    &.ev-offline {
        background: linear-gradient(135deg, #fff3e0 0%, #fffaf3 100%);
        color: #e65100;
        border-color: rgba(230, 81, 0, 0.18);
        border-left-color: #e65100;

        .ev-badge {
            background: rgba(230, 81, 0, 0.12);
            color: #e65100;
        }
    }

    .ev-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        margin-bottom: 6px;
    }

    .ev-badge {
        display: inline-block;
        padding: 1px 6px;
        margin-bottom: 0;
        border-radius: 3px;
        font-size: 11px;
        line-height: 16px;
        background: rgba(1, 162, 253, 0.12);
        color: #01A2FD;
        flex-shrink: 0;
    }

    .ev-time {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        font-size: 11px;
        color: inherit;
        opacity: 0.85;
        white-space: nowrap;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        i {
            font-size: 12px;
        }
    }

    .ev-title {
        font-weight: 500;
        margin-bottom: 6px;
        line-height: 1.4;
        color: inherit;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 2.8em;
    }

    .ev-meta {
        display: flex;
        flex-direction: column;
        gap: 3px;
        font-size: 11px;
        opacity: 0.9;

        span {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            min-width: 0;

            i {
                font-size: 12px;
                flex-shrink: 0;
            }
        }
    }
}

.schedule-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 18px;
    padding: 8px 24px 20px;
    font-size: 12px;
    color: #888;

    span {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 10px;
        border-radius: 14px;
        background: #f7f9fc;
    }

    i {
        width: 10px;
        height: 10px;
        border-radius: 2px;
        display: inline-block;
    }

    .lg-online {
        background: #01A2FD;
    }

    .lg-live {
        background: #2e7d32;
    }

    .lg-offline {
        background: #e65100;
    }
}

.schedule-section {
    .schedule-tabs-wrap {
        display: flex;
        align-items: stretch;
        border-bottom: 1px solid var(--border);
        background: #fafbfd;
        overflow: hidden;
        position: relative;
    }

    .schedule-tabs-nav {
        flex-shrink: 0;
        width: 32px;
        border: none;
        background: #fafbfd;
        color: #01A2FD;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        padding: 0;
        position: relative;
        z-index: 2;

        &:hover:not(.is-disabled) {
            background: #EAF6FF;
        }

        &.is-disabled {
            color: #c5cdd8;
            cursor: default;
        }
    }

    .schedule-tabs {
        flex: 1;
        min-width: 0;
        padding: 0;
        border-bottom: none;
        flex-wrap: nowrap;
        overflow: hidden;
        position: relative;
    }

    .schedule-tabs-btns {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none;
        }
    }

    .schedule-tabs .region-btn {
        flex: 0 0 140px;
        width: 140px;
        max-width: 140px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 16px 10px;
        text-align: center;

        &.is-active::after {
            left: 12px;
            right: 12px;
        }
    }

    .schedule-tabs-empty {
        padding: 12px 24px;
        font-size: 13px;
        color: #999;
        background: #fafbfd;
        border-bottom: 1px solid var(--border);
    }
}

.region-metrics {
    padding: 18px;
    border-bottom: 1px solid var(--border);
    background: linear-gradient(180deg, #f7fbff 0%, #fff 100%);
}

.metrics-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.metric-card {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 8px;
    padding: 14px 16px;
    box-shadow: 0 1px 6px rgba(1, 162, 253, 0.04);
    min-height: 0;
    display: flex;
    flex-direction: column;

    h4 {
        margin: 0 0 12px;
        font-size: 13px;
        font-weight: 600;
        color: #333;
        flex-shrink: 0;
    }
}

.hbar-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &.is-scrollable {
        max-height: 248px;
        overflow-y: auto;
        padding-right: 4px;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: rgba(1, 162, 253, 0.35) transparent;

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
            margin: 4px 0;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(1, 162, 253, 0.28);
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(1, 162, 253, 0.5);
        }

        &::-webkit-scrollbar-button {
            display: none;
            width: 0;
            height: 0;
        }
    }
}

.hbar-row {
    display: grid;
    grid-template-columns: 52px 1fr auto;
    align-items: center;
    gap: 10px;
}

.hbar-label {
    font-size: 12px;
    color: #666;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hbar-track {
    height: 10px;
    background: #eef3f8;
    border-radius: 5px;
    overflow: hidden;
}

.hbar-fill {
    height: 100%;
    border-radius: 5px;

    &.c1 {
        background: linear-gradient(90deg, #5ba3f5, #01A2FD);
    }

    &.c2 {
        background: linear-gradient(90deg, #67c23a, #4caf50);
    }

    &.c3 {
        background: linear-gradient(90deg, #f7b731, #f5a623);
    }

    &.c4 {
        background: linear-gradient(90deg, #9b8cff, #7b6cf0);
    }

    &.c5 {
        background: linear-gradient(90deg, #36cfc9, #13c2c2);
    }

    &.c6 {
        background: linear-gradient(90deg, #f07878, #e85d5d);
    }
}

.hbar-value {
    font-size: 12px;
    font-weight: 600;
    color: #333;
    font-variant-numeric: tabular-nums;
    min-width: 88px;
    text-align: right;
    white-space: nowrap;
}

.table-scroll {
    overflow-x: auto;
}

.pager-wrap {
    padding: 8px 16px 16px;
}

.space-block-empty {
    padding: 24px 16px 32px;
    border-top: 1px solid var(--border);
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
        text-align: left;
        padding: 16px 20px;
        background: rgba(250, 251, 255, 1);
        font-weight: 400;
        color: #666;
        font-size: 13px;
        white-space: nowrap;
    }

    td {
        padding: 16px 20px;
        border-bottom: 1px solid var(--border);
        color: #666;
        line-height: 1.4;
    }

    tbody tr:hover td:not(.empty-cell) {
        background: #EAF6FF;
    }

    .name-cell {
        color: #333;
        font-weight: 400;
    }

    .empty-cell {
        padding: 0;
        border-bottom: none;
        background: transparent !important;
    }
}

.prov-tag {
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 400;
    color: #01A2FD;
    background: #EAF6FF;
    border-radius: 3px;
    margin-right: 4px;
}

.courses-section {
    margin-bottom: 25px;
}

.course-body {
    min-height: 160px;
    position: relative;
}

.course-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 25px 30px 30px;
}

.course-empty {
    width: 100%;
    min-height: 180px;
    padding: 25px 30px 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.course-tile {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid var(--border);
    background: #fff;
    text-decoration: none;
    color: inherit;
}

.course-thumb {
    width: 100%;
    height: 120px;
    background: linear-gradient(135deg, rgba(1, 162, 253, 0.75), rgba(23, 105, 250, 0.5)), linear-gradient(160deg, #1769FA, #01A2FD);
    position: relative;
    display: flex;
    align-items: flex-end;
    padding: 12px;
    box-sizing: border-box;
}

.course-badge {
    padding: 3px 10px;
    background: rgba(255, 200, 50, 0.95);
    color: #5a3a00;
    font-size: 12px;
    font-weight: 400;
    border-radius: 3px;
}

.course-meta {
    padding: 14px 12px 16px;

    h4 {
        font-size: 14px;
        font-weight: 700;
        margin: 0 0 8px;
        line-height: 1.4;
        color: #333;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .course-desc,
    p {
        font-size: 12px;
        color: #999;
        margin: 0;
        line-height: 1.5;
        min-height: 36px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.course-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.course-tag {
    padding: 2px 8px;
    font-size: 12px;
    color: #01A2FD;
    background: #EAF6FF;
    border-radius: 3px;
}

.showcase {
    margin-bottom: 25px;
}

.showcase-body {
    padding: 28px 18px 24px;
    background: #fff;
    position: relative;
}

.showcase-carousel-wrap {
    width: 100%;
    max-width: 860px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
}

.showcase-stage {
    flex: 1;
    min-width: 0;
}

.showcase-main {
    width: 100%;
    height: auto;
    overflow: hidden;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 28px rgba(1, 162, 253, 0.16);
    border: 1px solid rgba(1, 162, 253, 0.12);
    position: relative;
}

.showcase-track {
    display: flex;
    height: auto;
    transition: transform 0.45s ease;
}

.showcase-slide {
    flex: 0 0 100%;
    min-width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    color: inherit;
    text-decoration: none;
    box-sizing: border-box;
}

.showcase-slide-cover {
    flex: none;
    width: 100%;
    aspect-ratio: 16 / 9;
    min-height: 0;
    display: flex;
    align-items: flex-end;
    padding: 18px 22px 20px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    background:
        radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.45), transparent 40%),
        linear-gradient(145deg, #7ec2ff 0%, #cfe8ff 55%, #eaf6ff 100%);
    background-size: cover;
    background-position: center;

    &.is-media {
        padding: 0;
        align-items: stretch;
        background: #000;

        &::after {
            display: none;
        }

        .cover-tag {
            position: absolute;
            left: 18px;
            bottom: 16px;
        }
    }

    &.c2 {
        background:
            radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.4), transparent 40%),
            linear-gradient(145deg, #6fd3a0 0%, #c8f0db 55%, #eaf9f1 100%);
    }

    &.c3 {
        background:
            radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.4), transparent 40%),
            linear-gradient(145deg, #f0a85a 0%, #ffd9ae 55%, #fff4e8 100%);
    }

    &.c4 {
        background:
            radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.4), transparent 40%),
            linear-gradient(145deg, #8f7dff 0%, #d4cbff 55%, #f2eeff 100%);
    }

    &.c5 {
        background:
            radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.4), transparent 40%),
            linear-gradient(145deg, #f07878 0%, #ffc8c8 55%, #ffeeee 100%);
    }

    .showcase-media {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: #000;
        display: block;
    }

    .cover-play {
        position: absolute;
        right: 36px;
        top: 50%;
        transform: translateY(-58%);
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.35);
        border: 2px solid rgba(255, 255, 255, 0.7);
        pointer-events: none;
        z-index: 1;

        &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 0 10px 16px;
            border-color: transparent transparent transparent rgba(255, 255, 255, 0.95);
            transform: translate(-35%, -50%);
        }
    }

    .cover-deco {
        position: absolute;
        right: 36px;
        top: 50%;
        transform: translateY(-58%);
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 2px solid rgba(255, 255, 255, 0.45);
        box-shadow: inset 0 0 0 14px rgba(255, 255, 255, 0.12);
        pointer-events: none;

        &::before {
            content: "";
            position: absolute;
            inset: 28px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.22);
        }

        &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 12px 0 12px 20px;
            border-color: transparent transparent transparent rgba(255, 255, 255, 0.9);
            transform: translate(-35%, -50%);
        }
    }

    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 45%;
        background: linear-gradient(180deg, transparent, rgba(0, 40, 80, 0.22));
        pointer-events: none;
    }

    .cover-tag {
        position: relative;
        z-index: 1;
        font-size: 12px;
        color: #fff;
        font-weight: 400;
        padding: 5px 12px;
        background: rgba(1, 162, 253, 0.92);
        border-radius: 3px;
        letter-spacing: 0.5px;
        box-shadow: 0 2px 8px rgba(1, 162, 253, 0.25);
    }
}

.showcase-slide-info {
    flex-shrink: 0;
    padding: 18px 24px;
    background: #fff;
    border-top: 1px solid #f0f3f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    min-height: 78px;
    box-sizing: border-box;
}

.info-main {
    flex: 1;
    min-width: 0;

    h4 {
        font-size: 16px;
        font-weight: 400;
        margin: 0 0 8px;
        line-height: 1.4;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    p {
        font-size: 13px;
        color: #999;
        margin: 0;
        line-height: 1.4;
        display: flex;
        align-items: center;
        gap: 4px;
        overflow: hidden;

        i {
            color: #01A2FD;
            font-size: 14px;
            flex-shrink: 0;
        }

        span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.info-more {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-size: 13px;
    color: #01A2FD;
    padding: 7px 14px;
    border: 1px solid rgba(1, 162, 253, 0.45);
    border-radius: 16px;
    background: #EAF6FF;
    line-height: 1;
    cursor: pointer;
    font-family: inherit;

    i {
        font-size: 12px;
    }
}

.showcase-slide:hover {
    .info-main h4 {
        color: #01A2FD;
    }

    .info-more {
        background: #01A2FD;
        color: #fff;
        border-color: #01A2FD;
    }
}

.showcase-arrow {
    position: static;
    transform: none;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #1769FA;
    border: none;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(23, 105, 250, 0.25);

    &:hover {
        background: #01A2FD;
    }

    &.prev,
    &.next {
        left: auto;
        right: auto;
    }
}

.showcase-dots {
    position: static;
    left: auto;
    right: auto;
    bottom: auto;
    display: flex;
    justify-content: center;
    gap: 8px;
    z-index: 2;
    pointer-events: none;
    margin-top: 12px;

    .showcase-dot {
        pointer-events: auto;
    }
}

.showcase-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d8dde6;
    padding: 0;
    border: none;
    cursor: pointer;
    box-shadow: none;

    &.is-active {
        background: #1769FA;
        border-color: #1769FA;
        width: 20px;
        border-radius: 4px;
    }
}

@media screen and (min-width: 1250px) {
    .banner-wrapper {
        /deep/ .el-carousel__container {
            height: 520px;
        }

        .banner-title {
            margin-top: 145px;
            font-size: 60px;
            margin-bottom: 52px;
        }

        .banner-subtitle {
            font-size: 20px;
            width: 1200px;
            max-width: 90%;
        }
    }

    .ph-wrap {
        width: 1200px;
    }

    .showcase-carousel-wrap {
        width: 960px;
    }

    .showcase-main {
        height: auto;
    }

    .more-link,
    .notice-more {
        font-size: 15px;
    }

    .news-title {
        font-size: 15px;
    }

    .notice-item-title {
        font-size: 14px;
    }

    .notice-date {
        .day {
            font-size: 36px;
        }

        .md {
            font-size: 15px;
        }
    }

    .section-hd h3 {
        font-size: 18px;
    }
}

@media (max-width: 960px) {
    .row-top {
        grid-template-columns: 1fr;
    }

    .metrics-grid {
        grid-template-columns: 1fr;
    }

    .course-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .schedule-grid {
        grid-template-columns: repeat(4, 1fr);
    }

    .banner-title {
        font-size: 28px !important;
        margin-top: 80px !important;
    }
}

@media (max-width: 600px) {
    .course-grid,
    .schedule-grid {
        grid-template-columns: 1fr;
    }

    .stats-bar {
        gap: 20px;
    }
}
</style>
